import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import basicCss from 'src/utils/basic.module.scss';
import css from './footer.module.scss';
import * as r from 'src/constants/routes';
import { ReactComponent as ZsuLogo } from 'src/assets/zsu-logo.svg';
import { ReactComponent as FacebookIcon } from 'src/assets/facebook.svg';
import Feedback from 'src/pages/feedback/feedback';
import { ReactComponent as LogoOriginIcon } from 'src/assets/cvs_logo_orig.svg';
import classNames from 'classnames';
import SubscriptionForm from '../../subscribe/subscription-form';
import SuccesModal from 'src/components/subscribe/modals/succes-modal';

export default function Footer() {
  const [email, setEmail] = useState('');
  const year = new Date().getFullYear();

  const handleSubscribe = (email: string) => setEmail(email);

  return (
    <footer className={css.footer}>
      <div className={css.container}>
        <div className={css.topContainer}>
          <div className={css.logoTextContainer}>
            <Link to={r.GENERAL.path}>
              <p className={css.logo}>
                <LogoOriginIcon />
                На зв'язку
              </p>
            </Link>
            <p>Допомагаємо захисникам та їхнім родинам отримати доступ до працюючих рішень на єдиному ресурсі</p>
            <SubscriptionForm onSubmit={handleSubscribe} />
          </div>
          <div className={css.footerMenuContainer}>
            <div className={css.servicesContainer}>
              <h4>Послуги</h4>
              <div className={css.links}>
                <nav>
                  <ul>
                    {r.SERVICES_ROUTES.map((service) => (
                      <li key={service.title} /* NOSONAR */>
                        <NavLink to={service.path}>{service.title}</NavLink>
                      </li>
                    ))}
                  </ul>
                </nav>
                <nav>
                  <ul>
                    {r.SERVICES_WITH_ICONS.map((service) => (
                      <li key={service.title} /* NOSONAR */>
                        {service.meta.menuIcon}
                        <NavLink to={service.path}>{service.title}</NavLink>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className={css.feedbackContainer}>
              <div className={css.questions}>
                <h4>Маєте запитання?</h4>

                <p>Email платформи:</p>
                <a
                  href='mailto: nazviazku@nazviazku.zsu.gov.ua'
                  className={classNames(basicCss.hoverUnderline, basicCss.cursorPointer)}>
                  nazviazku@nazviazku.zsu.gov.ua
                </a>

                <a
                  href='https://www.facebook.com/cimicUA'
                  className={classNames(basicCss.hoverUnderline, basicCss.cursorPointer)}>
                  <FacebookIcon />
                  Ми в соціальних мережах
                </a>
                <Feedback trigger={<p className={css.clickable}>Залишити відгук</p>} />
                <NavLink to={r.PARTNERSHIP.path}>Партнери та надавачі послуг</NavLink>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className={css.bottomContainer}>
          <div className={css.policiesContainer}>
            <ZsuLogo className={css.zsuLogo} />
            <div className={css.politics}>
              <NavLink to={r.PERSONAL_DATA_POLICIES.path}>Політика конфіденційності</NavLink>
              <NavLink to={r.COOKIES_POLICIES.path}>Політика кукі</NavLink>
            </div>
          </div>
          <div className={css.copyrightContainer}>
            <div className={css.testModeContainer}>
              <p className={css.testMode}>Beta</p>
              <p className={css.testModeMessage}>Функціонал працює в режимі дослідної експлуатації</p>
            </div>
            <p>© {year} Збройні сили України. Всі права захищені.</p>
          </div>
        </div>
      </div>
      <SuccesModal isOpen={email.length > 0} email={email} onClose={() => setEmail('')} />
    </footer>
  );
}
